import validarDocumento_pt from './locales/pt/validarDocumento.json'
import validarDocumento_en from './locales/en/validarDocumento.json'
import detalheDocumento_pt from './locales/pt/detalheDocumento.json'
import detalheDocumento_en from './locales/en/detalheDocumento.json'
import {initReactI18next} from "react-i18next";
import i18n from 'i18next';

export const resources = {
    pt: {
        validarDocumento: validarDocumento_pt,
        detalheDocumento: detalheDocumento_pt
    },
    en: {
        validarDocumento: validarDocumento_en,
        detalheDocumento: detalheDocumento_en
    }

}

i18n.use(initReactI18next).init({
    lng: "pt",
    fallbackLng: "pt",
    interpolation: {
        escapeValue: false,
    },
    resources,
    returnNull: false
});

export default i18n;